import { Trans } from 'react-i18next';
import {
  ExcelExportRequestDto,
  TableauShareActionsConfigDto,
  TableShareActionsConfigDto,
  VegaChartShareActionsConfigDto,
} from '@asset-metrix/portal-gateway-client-js';
import { WidgetMoreAction } from '@asset-metrix/portal-ui';
import dayjs from 'dayjs';
import { TFunction } from 'i18next/typescript/t';

import { datatableExcelDownload } from '../../api/portalGateway/datatableExcelExport';
import { DOWNLOAD_DATE_PREFIX_FORMAT } from '../../config';
import { actionWithAsyncNotification } from '../../utils/actionWithAsyncNotification';

export function widgetShareAction(
  widgetId: string,
  widgetTitle: string,
  action:
    | TableShareActionsConfigDto
    | TableauShareActionsConfigDto
    | VegaChartShareActionsConfigDto,
  t: TFunction,
  {
    pageFilterSelections,
    tableFilterSelections,
    workflowStateSelection,
  }: {
    pageFilterSelections?: ExcelExportRequestDto['selection'];
    tableFilterSelections?: ExcelExportRequestDto['selection'];
    workflowStateSelection?: ExcelExportRequestDto['workflowStateSelection'];
  } = {}
): WidgetMoreAction {
  let fileName = '';
  switch (action.actionKey) {
    case 'excelDownload':
      fileName = `${dayjs().format(DOWNLOAD_DATE_PREFIX_FORMAT)} ${widgetTitle || `data-export-filtered-${widgetId}`}`;
      return {
        label: t('app.widget.action.label.excelDownloadFiltered'),
        tooltip: t('app.widget.action.tooltip.excelDownloadFiltered'),
        cb: async () => {
          actionWithAsyncNotification(
            () =>
              datatableExcelDownload({
                fileName,
                selection: {
                  ...pageFilterSelections,
                  ...tableFilterSelections,
                },
                widgetId,
                workflowStateSelection,
              }),
            {
              startMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.loading"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              successMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.success"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              errorMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.error"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              showBackLink: true,
            }
          );
        },
      };
    case 'excelDownloadUnfiltered':
      fileName = `${dayjs().format(DOWNLOAD_DATE_PREFIX_FORMAT)} ${widgetTitle || `data-export-${widgetId}`}`;
      return {
        label: t('app.widget.action.label.excelDownloadUnFiltered'),
        tooltip: t('app.widget.action.tooltip.excelDownloadUnFiltered'),
        cb: async () => {
          actionWithAsyncNotification(
            () =>
              datatableExcelDownload({
                fileName,
                widgetId,
              }),
            {
              startMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.loading"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              successMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.success"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              errorMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.error"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              showBackLink: true,
            }
          );
        },
      };
    case 'excelDownloadReadOnly':
      fileName = `${dayjs().format(DOWNLOAD_DATE_PREFIX_FORMAT)} ${widgetTitle || `data-export-${widgetId}`}`;
      return {
        label: t('app.widget.action.label.excelDownloadReadOnly'),
        tooltip: t('app.widget.action.tooltip.excelDownloadReadOnly'),
        cb: async () => {
          actionWithAsyncNotification(
            () =>
              datatableExcelDownload({
                fileName,
                readOnly: true,
                selection: {
                  ...pageFilterSelections,
                  ...tableFilterSelections,
                },
                widgetId,
                workflowStateSelection,
              }),
            {
              startMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.loading"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              successMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.success"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              errorMessage: (
                <Trans
                  i18nKey="app.notifications.excelExport.error"
                  components={[<b />]}
                  values={{ fileName }}
                />
              ),
              showBackLink: true,
            }
          );
        },
      };
    default:
      return {
        disabled: true,
        label: `${action.actionKey} not implemented`,
      };
  }
}
